<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <div class='btn-toolbar pull-right'>
          <div class='btn-group'>
            <div class="btn btn-primary btn-sm btn-action" ng-click="new()" ng-if="permissions.tipos_ocorrencia.canManage" ng-hide="openedTipoOcorrencia"
                 uib-tooltip="Novo Tipo de Ocorrência" tooltip-placement="left">
              Novo <i class="fa fa-plus"></i>
            </div>
          </div>
        </div>
        <h2>Tipos de Ocorrências</h2>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12" ng-class="{'col-md-6': openedTipoOcorrencia}">
      <div class="row" ng-include="'views/tipos_ocorrencias/_filtros.html'"></div>
      <div class="row" ng-include="'views/tipos_ocorrencias/_list.html'"></div>
    </div>

    <div class="col-xs-12 col-md-6" ng-show="openedTipoOcorrencia">
      <ng-include ng-controller="TipoOcorrenciaCtrl" src="'views/tipos_ocorrencias/_new.html'"></ng-include>
    </div>
  </div>
</page-data-manager>
